import { Button, Paragraph, Space } from "task-eva-ui";
import {
  UserInfoCount,
  UserInfoCountWrapper,
  UserInfoSection,
  UserLevelText,
  XgtVipButton,
} from "./atom";
import { CouponSection } from ".";
import { IUserInfoProps } from "./type";
import { XgtMark } from "./atom";
import { XgtTip } from "./atom";
import { getExpireDate } from "./helper/get-expire-date";
import { isEn, userCenterHost } from "project-config/utils/env";
import { getUserLevelIcon } from "./helper/get-user-level-info";
import { useEffect, useState } from "react";
import { getTranslateNsT } from "./i18n";
import { Whether } from "project-config/constants";
import { CouponType } from "./type";

export function RenderTab({
  userInfo,
  toRecharge,
  close,
  toCoupon,
  toPictureVip,
}: IUserInfoProps) {
  const {
    isSubAccount,
    isPictureUser,
    userLevel,
    userBalance,
    userCredit,
    userCouponCount,
    userCouponPrice,
    vocherCount,
    vocherExpireDate,
    qyCouponCount,
    qyCoupon,
    isDomestic,
    currencySymbol,
    isFirstRecharge,
    isHideBalance,
    userTotalCredit,
    picMemberValidity,
    memberLevelTranslate,
  } = userInfo;
  const t = getTranslateNsT(isEn() ? "en" : "zh");
  const [isShowCredit, setIsShowCredit] = useState(true);
  useEffect(() => {
    if (isSubAccount) {
      setIsShowCredit(userCredit !== 0);
    } else {
      setIsShowCredit(userTotalCredit !== 0);
    }
  }, [isSubAccount, userCredit, userTotalCredit]);

  const renderIconLevel = () => {
    return (
      <Space gap={5} center height="20px">
        {getUserLevelIcon(userLevel || 0)}
        <UserLevelText level={userLevel || 0}>
          {memberLevelTranslate}
        </UserLevelText>
      </Space>
    );
  };
  return (
    <Space direction="column" gap={8} width="100%">
      {!isSubAccount && isPictureUser && (
        <UserInfoSection height="64px" padding="8px 12px 0">
          <XgtMark className={!!userLevel ? "active" : ""}>
            {t(`xgt_vip_tip_${userLevel}`)}
          </XgtMark>
          {renderIconLevel()}
          {userLevel === 0 ? (
            <XgtTip>{t("xgt_vip_gift_tip")}</XgtTip>
          ) : (
            <XgtTip>
              {t("xgt_vip_expire_date")}
              {getExpireDate(picMemberValidity || "")}
            </XgtTip>
          )}
          <XgtVipButton
            onClick={() => {
              toPictureVip?.();
              window.open(
                `${userCenterHost}/topUp?activeName=picture-vip-item`
              );
            }}
          >
            {t(`xgt_vip_button_${userLevel}`)}
          </XgtVipButton>
        </UserInfoSection>
      )}
      {!isHideBalance && (
        <UserInfoSection
          height={
            isHideBalance
              ? "40px"
              : isSubAccount
              ? "105px"
              : isPictureUser
              ? "114px"
              : "148px"
          }
          padding={isSubAccount ? "10px 10px 19px 10px" : "10px"}
        >
          <Space column fitParent gap={14}>
            {(!isPictureUser || isSubAccount) && renderIconLevel()}
            {!isHideBalance && (
              <Space column gap={14} width="100%">
                <UserInfoCountWrapper>
                  <UserInfoCount>
                    <div className="title">
                      {t("user_balance")}
                      {!isDomestic && `(${currencySymbol})`}
                    </div>
                    <div className="content">
                      {isDomestic && (
                        <div className="symbol">{currencySymbol || ""}</div>
                      )}
                      <div className="value">
                        <Paragraph text={userBalance || "0"} maxWidth="120px" />
                      </div>
                    </div>
                  </UserInfoCount>
                  <UserInfoCount left="146px">
                    {isShowCredit && (
                      <>
                        <div className="title">
                          {t("user_credit")}
                          {!isDomestic && `(${currencySymbol})`}
                        </div>
                        <div className="content">
                          {isDomestic && (
                            <div className="symbol">{currencySymbol || ""}</div>
                          )}
                          <div className="value">
                            <Paragraph
                              text={userCredit || "0"}
                              maxWidth="120px"
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </UserInfoCount>
                </UserInfoCountWrapper>
                {!isSubAccount && (
                  <Button
                    height="38px"
                    width="100%"
                    onClick={() => {
                      toRecharge?.();
                      close?.();
                    }}
                  >
                    {isFirstRecharge === Whether.No
                      ? t("first_recharge")
                      : t("recharge")}
                  </Button>
                )}
              </Space>
            )}
          </Space>
        </UserInfoSection>
      )}
      {!isHideBalance && (
        <>
          <CouponSection
            onClick={() => {
              toCoupon?.(CouponType.Animation);
              close?.();
            }}
            isDomestic={!!isDomestic}
            isPictureUser={false}
            currencySymbol={currencySymbol}
            couponTitle={t("coupon")}
            couponCount={userCouponCount}
            couponPrice={userCouponPrice}
          />
          {isDomestic && (
            <CouponSection
              onClick={() => {
                toCoupon?.(
                  isPictureUser ? CouponType.RenderingMember : CouponType.Qing
                );
                close?.();
              }}
              isDomestic={isDomestic}
              isPictureUser={!!isPictureUser}
              currencySymbol={currencySymbol}
              couponTitle={t(isPictureUser ? "vocher" : "qcoupon")}
              couponCount={isPictureUser ? vocherCount : qyCouponCount}
              couponPrice={isPictureUser ? vocherExpireDate : qyCoupon}
            />
          )}
        </>
      )}
    </Space>
  );
}
